export default class LocalStorageHelper{ 
	static getObj(name)
	{
		try
		{
			var item = window.localStorage.getItem(name);
			if(item===undefined||item===null)return;
			return JSON.parse(item);
		}
		catch(ex)
		{
			return undefined;
		}
	}
	static setObj(name, obj)
	{
		try
		{
			window.localStorage.setItem(name, JSON.stringify(obj));
		}
		catch(ex)
		{
			console.error(ex);
		}
	}
};